import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import homework_V2Service from '../../services/homework_V2.service';
import models_V2Service from '../../services/models_V2.service';
import ComponentTable from '../ComponentTable';
// class GroupHistoryHw extends React.Component {
//     constructor(props) {
//         super(props);
//         this.getData();
//         this.state = {
//             data: [],
//             loading: true,
//             no_data: false,
//         };
//     }

//     getDate(item) {
//         let d = new Date(item);
//         // eslint-disable-next-line
//         if (d == 'Invalid Date') d = new Date(JSON.parse(item));
//         const _min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
//         const _hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
//         const _month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
//         const _date = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
//         const date = `${_date}.${_month}.${d.getFullYear()} ${_hours}:${_min}`;
//         return date;
//     }

//     processTheme(item) {
//         const { t } = this.props;
//         const _item = [
//             {
//                 label: t('groups.age'),
//                 value: -1,
//             },
//             {
//                 label: t('groups.junior'),
//                 value: 0,
//             },
//             {
//                 label: t('groups.senior'),
//                 value: 1,
//             },
//             {
//                 label: t('groups.55+'),
//                 value: 2,
//             },
//         ];
//         return _item.find(el => el.value === parseInt(item)).label;
//     }

//     dNumber(item) {
//         return new Date(item).getTime();
//     }

//     async getData() {
//         let data = await this.props.getGroupHistoryHw(false, {
//             id: this.props.data.id,
//             size: 999,
//         });
//         data = data.list;
//         if (!data.length) return this.setState({ no_data: true });
//         let _data = [];
//         data.sort((a, b) =>
//             this.dNumber(a.date) > this.dNumber(b.date) ? (this.dNumber(a.date) < this.dNumber(b.date) ? 0 : -1) : 1
//         );
//         // arrToSave.sort( (a,b) => a.order > b.order ? b.order > a.order ? 0 : 1 : -1);
//         data.map((item, index) => {
//             _data.push([{ value: this.getDate(item.date) }, { value: item.template_id }, { value: item.topic }]);
//             return _data;
//         });
//         this.setState({ loading: false, data: _data });
//     }

//     render() {
//         const { t } = this.props;
//         return (
//             <Fragment>
//                 {this.state.no_data ? (
//                     <Box component="span" m={1}>
//                         {t('arcards.no_data')}
//                     </Box>
//                 ) : null}

//                 {this.state.loading && !this.state.no_data ? (
//                     <div>
//                         <Box component="span" m={1}>
//                             <Skeleton variant="rect" width={'100%'} height={40} />
//                         </Box>
//                         <Box component="span" m={1}>
//                             <Skeleton variant="rect" width={'100%'} height={40} />
//                         </Box>
//                         <Box component="span" m={1}>
//                             <Skeleton variant="rect" width={'100%'} height={40} />
//                         </Box>
//                     </div>
//                 ) : null}
//                 {this.state.data.length ? (
//                     <TableContainer component={Paper}>
//                         <Table aria-label="simple table">
//                             <TableHead>
//                                 <TableRow>
//                                     <TableCell>{t('table.date')}</TableCell>
//                                     <TableCell>{t('groups.group_type')}</TableCell>
//                                     <TableCell>{t('groups.theme')}</TableCell>
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {this.state.data.length &&
//                                     this.state.data.map((row, index) => {
//                                         return (
//                                             <TableRow key={index}>
//                                                 {row.map((el, i) => {
//                                                     return (
//                                                         <TableCell key={i} className={el.edit ? 'edited' : ''}>
//                                                             {el.value}
//                                                         </TableCell>
//                                                     );
//                                                 })}
//                                             </TableRow>
//                                         );
//                                     })}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 ) : null}
//             </Fragment>
//         );
//     }
// }

// const widthConnect = connect(
//     state => ({
//         requestmodal: state.modalWindow.requestmodal,
//     }),
//     dispatch => bindActionCreators({ getGroupHistoryHw }, dispatch)
// );

// export default withTranslation()(widthConnect(GroupHistoryHw));

function GroupHistoryHw() {
    const { t } = useTranslation();
    const { isEmpty } = useSelector(state => state.AsyncTable.table);
    const history = useHistory();
    const { groupId } = useParams();

    const actions = [
        {
            title: t('quiz.more'),
            onClick: (_, row) => history.push(`/groups/${groupId}/hwHistory/${row.id}`),
            outOfMenu: true,
            Icon: OpenInNewIcon,
        },
    ];

    return (
        <>
            <Button
                onClick={() => history.push(`/groups/${groupId}`)}
                style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '5px', color: 'black' }}
            >
                <ArrowBackIosNewIcon
                    style={{
                        fontSize: '12px',
                    }}
                />
                {t('buttons.back')}
            </Button>
            <Typography component="h2" className="container-header" pb={1}>
                {t('groups.HW_change_history')}
            </Typography>
            <ComponentTable
                source={{
                    getData: (page, size, sort, filter) =>
                        homework_V2Service.getGroupHistoryHwNew(false, {
                            page: page || 0,
                            size: size || 10,
                            orderBy: (sort && sort.orderBy) || null,
                            order: (sort && sort.order) || 'asc',
                            filter,
                            id: groupId,
                        }),

                    getModel: () => models_V2Service.getGroupHistoryHw(),
                }}
                actions={actions}
                selectable={true}
                enableFilter={isEmpty ? false : true}
                title={t('modals.list')}
                enableSettings
                toolbarvisible={true}
                typeTable="moneybox"
            />
        </>
    );
}

export default GroupHistoryHw;
